<template>
	<modal
		:title="title"
		id="create_version"
		cancel-label="Close"
		continue-label="Save changes"
		v-on:closed="cancel"
		v-on:confirm="saveChanges"
    :showModal="showModal"
	>
		<template v-slot:body>
      <br>
      <div class="form-group row" v-if="errors.length">
          <div class="alert alert-danger">
              <b>Please correct the following error(s):</b>
              <ul>
                  <li v-for="error in errors">{{ error }}</li>
              </ul>
          </div>
      </div>
			<div class="form-group row">
        <div class="col-sm-2 col-sm-offset-1">
          <label for="version">Version:</label>
        </div>
        <div class="col-sm-7">
          <input type="text" v-model="version" class="form-control col-sm-7" id="version" v-on:keydown.enter.stop="saveChanges"/>
        </div>
      </div>
		</template>
	</modal>
</template>

<script setup>
  import { ref, computed } from 'vue'
	import Modal from '../../Modal.vue'

  const props = defineProps(['consent', 'showModal'])
  const emit = defineEmits(['input', 'closed', 'confirm'])

	const version = ref(null)
  const errors = ref([])

	function saveChanges() {
    let validated = validateForm()
    if (validated) {
			let data = {}
			data.version = version.value
      data.consent_id = props.consent.id
			emit('confirm', data)
      emit('input', false)
      clearForm()
    }
	}

  function validateForm() {
      if (version.value) {
          return true
      }
      if (!version.value) {
          errors.value.push("Version required.")
          return false
      }
  }

  function cancel() {
    emit('closed')
    emit('input', false)
    clearForm()
  }

  function clearForm() {
    version.value = null
    errors.value = []
  }

  const title = computed(() => {
    return "Add Version for "+ props.consent.name
  })
</script>